import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Activities from "./pages/Activities";
import ActivityDetail from "./pages/ActivityDetail";
import Account from "./pages/Account";
import ModificationValidated from "./pages/ModificationValidated";
import Reviews from "./pages/Reviews";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCanceled from "./pages/PaymentCanceled";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/activites" element={<Activities />} />
          <Route path="/activite/:id" element={<ActivityDetail />} />
          <Route path="/commande" element={<Checkout />} />
          <Route path="/connexion" element={<Login />} />
          <Route path="/compte" element={<Account />} />
          <Route path="/modification-validee" element={<ModificationValidated />} />
          <Route path="/avis" element={<Reviews />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-canceled" element={<PaymentCanceled />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
